
<div class="loading" *ngIf="dataLoading">
  <mat-spinner></mat-spinner>
</div>
<div *ngIf="!dataLoading">
    <div *ngFor="let category of latestItems | orderByGroup:'uploadDate':'asc'">
        <div class="category-slider-row" fxLayout="column" *ngIf="category.items.length > 4">
            <div fxLayout="row" fxLayoutAlign="start stretch">
                <div><span class="carousel-title">{{category.title}} - {{category.items.length}} Recent Files</span></div>
                <button mat-menu-item color="primary" class="catories-children-all" [routerLink]="['/products', category.id]">
                    See All
                </button>
            </div>
            <app-product-carousel fxFlex="0 0 100%" [items]="category.items" [configurationInput]="config"></app-product-carousel>

        </div>
    </div>


<!-- <div *ngFor="let category of topLevelCategories">
<app-category [thisCategory]="category" *ngIf="category.fileCount > 0"></app-category>
</div> -->




<p class="carousel-title">Favorites</p>
<app-product-carousel [title]="'Favorites'" [items]="favorites"></app-product-carousel>

</div>





// WEBPACK FOOTER //
// ./src/app/home-page/products-categories/products-categories.component.html